import React from 'react';
import key from 'weak-key';
import { getTranslation } from '../utils/config';
import { itemInformationTransform } from '../utils/transform-data';
import Card from './card/card';
import CardPlaceholder from './card/card-placeholder';
import Grid from './grid';
import { IResultContext, useDfContext } from '../context/df-context';
import { LoadingRing } from './loading-ring';
import { useLoader } from '../hooks/use-loader';

export default function GridResults(): React.ReactElement | null {
  const {
    state: { expandedCard, totalDownloads, results, loadMore, isFetching },
    fetchNextPage,
  } = useDfContext<IResultContext>();

  const isLoading = useLoader(!!isFetching);

  if (totalDownloads === 0 || !results) {
    return null;
  }

  const handleLoadMore = async () => {
    fetchNextPage();
  };

  return (
    <Grid>
      <section className="df-list-module-row" aria-live="polite" aria-atomic="true">
        {results &&
          results.map((group) => (
            <Card
              key={key(group)}
              {...group}
              {...itemInformationTransform(group)}
              expanded={expandedCard === group.pimId}
            />
          ))}
        {results && results.length < 3 && <CardPlaceholder width={3 - results.length} />}
      </section>
      {loadMore && (
        <div className="flex-grid-cta">
          <button disabled={isFetching} onClick={handleLoadMore} className="df-btn show-more">
            <span>{getTranslation('show_more')}</span>
            {isLoading ? (
              <LoadingRing />
            ) : (
              <span className="df-btn__icon-right df-icon-arrow_down_white" />
            )}
          </button>
        </div>
      )}
    </Grid>
  );
}
